<!-- CMS Wrapper -->
<div class="third-cms-wrapper bass-me">
  <!-- Editing UI -->
  <!-- Define CMS type, image OR text -->
  <div
    *ngIf="isAdmin"
    class="third-cms-edit"
    [ngClass]="{ 'background-transparent': !editToggle }"
  >
    <!-- Toggle Editing UI Button -->
    <button
      [ngClass]="{ 'button-down': editToggle, 'button-up': !editToggle }"
      (click)="editButton()"
    >
      <svg
        class="third-cms-edit-icon"
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 20 20"
      >
        <path
          *ngIf="!editToggle"
          d="M13.586 3.586a2 2 0 112.828 2.828l-.793.793-2.828-2.828.793-.793zM11.379 5.793L3 14.172V17h2.828l8.38-8.379-2.83-2.828z"
        />
        <path
          *ngIf="editToggle"
          fill-rule="evenodd"
          d="M4.293 4.293a1 1 0 011.414 0L10 8.586l4.293-4.293a1 1 0 111.414 1.414L11.414 10l4.293 4.293a1 1 0 01-1.414 1.414L10 11.414l-4.293 4.293a1 1 0 01-1.414-1.414L8.586 10 4.293 5.707a1 1 0 010-1.414z"
          clip-rule="evenodd"
        />
      </svg>
    </button>
    <!-- Toggle Editing UI Button -->

    <!-- Set CMS Type - Image  -->
    <button
      class="button-up"
      *ngIf="editToggle && cmsType == 0"
      (click)="setCmsType(1)"
    >
      <svg
        class="third-cms-edit-icon"
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 20 20"
      >
        <path
          fill-rule="evenodd"
          d="M4 3a2 2 0 00-2 2v10a2 2 0 002 2h12a2 2 0 002-2V5a2 2 0 00-2-2H4zm12 12H4l4-8 3 6 2-4 3 6z"
          clip-rule="evenodd"
        ></path>
      </svg>
    </button>
    <!-- Set CMS Type - Image  -->

    <!-- Set CMS Type - Text  -->
    <button
      class="button-up"
      *ngIf="editToggle && cmsType == 0"
      (click)="setCmsType(2)"
    >
      <svg
        class="third-cms-edit-icon"
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 20 20"
      >
        <path
          fill-rule="evenodd"
          d="M18 13V5a2 2 0 00-2-2H4a2 2 0 00-2 2v8a2 2 0 002 2h3l3 3 3-3h3a2 2 0 002-2zM5 7a1 1 0 011-1h8a1 1 0 110 2H6a1 1 0 01-1-1zm1 3a1 1 0 100 2h3a1 1 0 100-2H6z"
          clip-rule="evenodd"
        ></path>
      </svg>
    </button>
    <!-- Set CMS Type - Text  -->

    <!-- Upload Image Button -->
    <button
      class="button-up"
      *ngIf="editToggle && cmsType == 1"
      (click)="imageInput.click()"
    >
      <svg
        class="third-cms-edit-icon"
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 20 20"
      >
        <path
          fill-rule="evenodd"
          d="M3 17a1 1 0 011-1h12a1 1 0 110 2H4a1 1 0 01-1-1zM6.293 6.707a1 1 0 010-1.414l3-3a1 1 0 011.414 0l3 3a1 1 0 01-1.414 1.414L11 5.414V13a1 1 0 11-2 0V5.414L7.707 6.707a1 1 0 01-1.414 0z"
          clip-rule="evenodd"
        />
      </svg>
    </button>

    <input
      class="hide"
      type="file"
      #imageInput
      (change)="onFileChanged($event)"
    />
    <!-- Upload Image Button -->

    <!-- Edit Text Button  -->
    <button
      [ngClass]="{ 'button-down': textEdit, 'button-up': !textEdit }"
      *ngIf="editToggle && cmsType == 2"
      (click)="editText()"
    >
      <svg
        class="third-cms-edit-icon"
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 20 20"
      >
        <path
          d="M17.414 2.586a2 2 0 00-2.828 0L7 10.172V13h2.828l7.586-7.586a2 2 0 000-2.828z"
        />
        <path
          fill-rule="evenodd"
          d="M2 6a2 2 0 012-2h4a1 1 0 010 2H4v10h10v-4a1 1 0 112 0v4a2 2 0 01-2 2H4a2 2 0 01-2-2V6z"
          clip-rule="evenodd"
        />
      </svg>
    </button>
    <!-- Edit Text Button  -->

    <!-- Set CMS Type - None  -->
    <button
      class="button-up"
      *ngIf="editToggle && cmsType !== 0"
      (click)="setCmsType(0)"
    >
      <svg
        class="third-cms-edit-icon"
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 20 20"
      >
        <path
          fill-rule="evenodd"
          d="M9 2a1 1 0 00-.894.553L7.382 4H4a1 1 0 000 2v10a2 2 0 002 2h8a2 2 0 002-2V6a1 1 0 100-2h-3.382l-.724-1.447A1 1 0 0011 2H9zM7 8a1 1 0 012 0v6a1 1 0 11-2 0V8zm5-1a1 1 0 00-1 1v6a1 1 0 102 0V8a1 1 0 00-1-1z"
          clip-rule="evenodd"
        ></path>
      </svg>
    </button>
    <!-- Set CMS Type - None  -->
  </div>
  <!-- Editing UI -->

  <!-- Image -->
  <img
    [ngClass]="cmsClassDisplay[1]"
    class="third-cms-img bass-me"
    src="{{ imageUrl }}"
  />
  <!-- Image -->

  <!-- Text -->
  <section class="bass-me third-cms-text" [ngClass]="cmsClassDisplay[2]">
    <p *ngIf="!textEdit">{{ textString }}</p>
    <p
      *ngIf="textEdit"
      contenteditable="true"
      (input)="setTextContent($event.target.innerHTML)"
    >
      {{ textString }}
    </p>
  </section>
  <!-- Text -->
</div>
<!-- CMS Wrapper -->
